<script setup lang="ts">
import { useToasts } from '@/composables/useToasts'

const { activeToasts } = useToasts()
</script>

<template>
  <Teleport to="body">
    <div
      v-for="toast in activeToasts"
      :key="toast.id"
      :class="[
        'toast',
        { 'toast-success': toast.type === 'success', 'toast-error': toast.type === 'error' },
        { show: toast.visible },
      ]"
    >
      {{ toast.message }}
    </div>
  </Teleport>
</template>
